export default {
    'it-IT': {
        news: 'News',
        readAll: 'Leggi tutto',
    },
    'fr-FR': {
        news: 'Nouvelles',
        readAll: 'Tout lire',
    },
    'es-ES': {
        news: 'Noticias',
        readAll: 'Leer todo',
    },
    'en-GB': {
        news: 'News',
        readAll: 'Read all',
    },
    'en-US': {
        news: 'News',
        readAll: 'Read all',
    },
    'de-DE': {
        news: 'Nachrichten',
        readAll: 'Alles lesen',
    },
    'en-AU': {
        news: 'News',
        readAll: 'Read all',
    },
    'ja-JP': {
        news: 'News',
        readAll: 'Read all',
    },
    'ko-KR': {
        news: 'News',
        readAll: 'Read all',
    },
};
